// extracted by mini-css-extract-plugin
export default {"container":"TagsWrap_container__aEpxG","box":"TagsWrap_box__WrlUW"};